// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import './GeneralInformation.scss'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import { findIana } from 'windows-iana'
import { AccountSettingsSection } from '../AccountSettingsSection/AccountSettingsSection'
import DefaultProfileImage from '../../../images/waitingRoom/voidPhoto.png'
import { AccountsSettingsInfoRow } from '../AccountSettingsInfoRow/AccountsSettingsInfoRow'
import { getDefaultTimeZoneAbbreviation, getTimeZones, imageSize } from '../../../utils/common'
import { TIME_ZONE } from '../../../utils/constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const GeneralInformation = ({ toggleIsEditMode }) => {
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)

  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const profileImage = useSelector((state) => state.waitingRoomReducer.providerProfile.ImageUrl)
  const timezones = getTimeZones(allTimezones)
  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const { options, parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'quickMd' })
  const [imgStyleObject, setImgStyleObject] = useState({})
  const [profileFullName, setProfileFullName] = useState('')

  let timeZoneValue
  if (profile?.TimeZone) {
    timeZoneValue = findIana(profile.TimeZone)[0]
  } else {
    timeZoneValue = getDefaultTimeZoneAbbreviation()
  }
  // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
  const timeZoneInfoRowValue = parseTimezone(timeZoneValue).label?.replace('GMT', 'UTC')

  useEffect(() => {
    if (profile) {
      const profileName = [profile.Prefix, profile.FirstName, profile.LastName, profile.Suffix].join(' ')
      setProfileFullName(profileName)

      if (profile.ImageUrl) {
        imageSize(profile.ImageUrl).then((e) => {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          e.width > e.height ?
            setImgStyleObject({ height: '100%', width: '' })
          : setImgStyleObject({
              height: '',
              width: '100%',
            })
        })
      }
    }
  }, [profile])

  return (
    // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
    <AccountSettingsSection isWithEditBtn editModeBtnHandler={() => toggleIsEditMode(true)} title='General information'>
      <div className='account-settings-general-information-main-wrapper'>
        <div
          className='account-settings-general-information-image-wrapper'
          style={{ border: profileImage ? '1px solid #C2D5E2' : 'none' }}>
          <img
            className={
              profileImage ?
                'account-settings-general-information-image'
              : 'account-settings-general-information-default-image'
            }
            style={imgStyleObject}
            src={profileImage || DefaultProfileImage}
            alt='profileImage'
          />
        </div>
        <div className='account-settings-general-information-info-wrapper'>
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <AccountsSettingsInfoRow keyValue='Full name:' value={profileFullName} />
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <AccountsSettingsInfoRow keyValue='Email:' value={profile.Email} />
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <AccountsSettingsInfoRow keyValue='Professional title:' value={profile.ProfessionalTitles?.join('; ')} />
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <AccountsSettingsInfoRow keyValue={`${TIME_ZONE}:`} value={timeZoneInfoRowValue} />
          {/*
           // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
          <AccountsSettingsInfoRow
            isTheLastItem
            keyValue='Phone number:'
            value={profile?.PhoneNumber?.Number ?? '--'}
          />
        </div>
      </div>
    </AccountSettingsSection>
  )
}
